import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EandoService } from '../../../../../api-services/eando.service';
import { EAndONote } from '../../../../../models/eando/eando-note.model';
import { EAndO } from '../../../../../models/eando/eando.model';
import { SharedService } from '../../../../../services';

@Component({
  selector: 'app-side-notes-error-omissions',
  templateUrl: './side-notes-error-omissions.component.html',
  styleUrls: ['./side-notes-error-omissions.component.css']
})
export class SideNotesErrorOmissionsComponent implements OnInit {

  @Input() sidePanelData;
  @Input() eandO: EAndO
  @Output() getEandONotesCountEvent = new EventEmitter<number>();

  eandONotes: EAndONote[] = [] as EAndONote[];
  detailNote: EAndONote = {} as EAndONote;
  eandODetailNote: FormGroup;

  constructor(private eandOService: EandoService, private sharedService: SharedService, private fb: FormBuilder) { }

  ngOnInit(): void {
    this.eandODetailNote = this.fb.group({
      memo: ['', [Validators.required, Validators.maxLength(500)]]
    });
    this.getEAndONotes();
  }

  ngOnChanges(changes: SimpleChanges) {
    this.ngOnInit();
  }

  getEAndONotes() {
    this.eandOService.getEAndONotes(this.eandO.eandOId).subscribe(response => {
      if (response) {
        this.eandONotes = response.map(el => ({
          ...el,
          createdOn: this.sharedService.convertUTCTimeToLocalTime(el.createdOn)
        }))
      }
      this.getEandONotesCountEvent.emit(this.eandONotes.length);
    })
  }

  submitNote() {
    this.eandODetailNote.markAllAsTouched();

    if (this.eandODetailNote.valid) {
      this.detailNote.eAndOId = this.eandO.eandOId;
      this.detailNote.memo = this.eandODetailNote.value.memo;
      
      this.eandOService.insertEAndONote(this.detailNote).subscribe(
        (response) => {
          if (response && response > 0) {
            this.getEAndONotes();
            this.eandODetailNote.get("memo").setValue('');
            this.eandODetailNote.markAsUntouched();
          }
          else {
            this.sharedService.showToastMessage("Oops! Something went wrong. Please try again.");
          }
        },
        (error) => {
          if (error && error.message != undefined) {
            this.sharedService.showToastMessage(error.message);
          }
          else {
            this.sharedService.showToastMessage("Oops! Something went wrong. Please try again.");
          }
        }
      );
    }
  }

  get isMemoValid(): boolean {
    return !!(this.eandODetailNote?.get('memo')?.value || '').trim();
  }


}
